// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qs-2";
export var chatLink = "_qs-0";
export var chatText = "_qs-1";